import { useWorkingDiff } from '~/lib/diff/use-working-diff'
import { TabContentDefaultWrapper } from '../../tab-content/wrapper'
import { BlockDiff } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/components/diff/block-diff'
import { EditorModeProvider } from '../../explore/components/editor-mode-provider'
import { parseTab, useTabsStore } from '../../explore/components/tabs/store'
import { BreadcrumbDashboard } from '../../explore/components/tabs/dashboard-breadcrumb'

export const WorkingBlockDiff = ({ blockId }: { blockId: string }) => {
  const diffResult = useWorkingDiff()
  const activeTab = useTabsStore((s) => s.activeTab)
  const parsedActiveTab = activeTab ? parseTab(activeTab) : null

  if (parsedActiveTab?.type !== 'block:diff') return null

  const change = diffResult.diff?.changesTree.getNode(parsedActiveTab.blockId)

  return (
    <>
      <BreadcrumbDashboard
        type="editor-diff"
        activeBlockId={parsedActiveTab.blockId}
        treeManager={
          change?.value.status === 'deleted'
            ? diffResult.treeOld || undefined
            : diffResult.treeNew || undefined
        }
      />
      <EditorModeProvider value="read">
        <TabContentDefaultWrapper size="lg" fullHeight>
          <BlockDiff blockId={blockId} diffResult={diffResult} enableComments />
          <div className="h-40" id="editor-filler" />
        </TabContentDefaultWrapper>
      </EditorModeProvider>
    </>
  )
}
